import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";

import { ROUTES } from "./defines/routes";

export const useFeaturedDealsAnalytics = (packagesDataList, heading) => {
  const { pathname } = useLocation();
  const { setAdobePageData } = useContext(MktgDataContext);

  useEffect(() => {
    if (shouldSetFeaturedDealsAnalytics() && packagesDataList.length) {
      const impressions = packagesDataList?.map((packageDataList, index) => {
        const { packageData } = packageDataList;
        const { hotelOption, id, flightOptions, prices = [] } = packageData;
        const originalPrice = prices[0]?.metadata?.label?.find(
          (item) => item.code === "PACKAGE_IBS_PER_PAX"
        )?.cash?.amount;
        const productPrice = prices[0]?.metadata?.label?.find(
          (item) => item.code === "PACKAGE_COST_PER_PAX"
        )?.cash?.amount;

        return {
          hotelid: hotelOption?.hotelCode ?? "",
          productcarousel: heading || "",
          productcode: id ?? "",
          productdestination: hotelOption?.address?.city ?? "",
          productorigin: flightOptions?.[1]?.arrival?.city ?? "",
          productoriginalprice: originalPrice?.toString() ?? "",
          productposition: `${index + 1}|${packagesDataList?.length}`,
          productprice: productPrice?.toString() ?? "",
          producttype: hotelOption?.hotelType?.toString() ?? "",
        };
      });

      setAdobePageData(
        {
          event: "impression",
          eventinfo: { eventtype: "content" },
        },
        "featuredDeals",
        impressions
      );
    }
  }, [packagesDataList.length, heading]);

  function shouldSetFeaturedDealsAnalytics() {
    return (
      pathname === ROUTES.vacations ||
      pathname.includes("/vacations/destinations/") ||
      pathname === ROUTES.deals
    );
  }
};
